import React from 'react';
import Spinner from '../ui/Spinner.component';

export const GridLoadingOverlay = props => {
	const { loadingMessage } = props;

	return (
		<div className="ag-overlay-loading-center">
			<Spinner msg={loadingMessage} mask={false} />
		</div>
	);
};
